import { useTranslation } from '@conekta/cronos/i18n';
import { Icon } from '@conekta/frontino-ui/Icon';
import { IconType } from '@conekta/frontino-ui/Icon/Icon';
import { CheckoutFrameContext } from 'app/context';
import { sendAnalytic } from 'app/util/analytics';
import { AnalyticEvents } from 'app/util/constants';
import { apiAmountToCurrencyString, currencyFormat } from 'app/util/currency';
import classNames from 'classnames';
import { useContext, useState } from 'react';

import AdditionalChargesSection from '../AdditionalChargesSection';
import ProductRow from '../ProductRow';

import './styles.scss';
import { SidebarWrapper } from '../SidebarWrapper';

export const ShoppingCartMobile = ({ setShowIntro, showIntro, customStyleJSON }: any) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const { checkoutRequest } = useContext(CheckoutFrameContext);
  const { id: orderId, companyId, orderTemplate, amount, type } = checkoutRequest;
  const { sidebar: shoppingCardStyles } = customStyleJSON || {};

  const canShowAdditionalLines =
    orderTemplate.shippingLines.length + orderTemplate.taxLines.length + orderTemplate.discountLines.length > 0;
  const tRoot = 'hostedCheckout.checkout.';
  const additionalChargesLabels = {
    subtotal: t('hostedCheckout.checkout.subtotal'),
    shipping: t('hostedCheckout.checkout.shipping'),
    tax: t('hostedCheckout.checkout.tax'),
    discount: t('hostedCheckout.checkout.discount'),
  };
  const parseCurrency = (amountRaw: number) =>
    currencyFormat(orderTemplate.currency, apiAmountToCurrencyString(amountRaw));
  const subtotal = orderTemplate.lineItems.reduce(
    (prev: any, current: any) => prev + current.unitPrice * current.quantity,
    0,
  );

  const handleClick = () => {
    setShowIntro(!showIntro);
    setExpanded(!expanded);
    if (!expanded) {
      sendAnalytic(AnalyticEvents.checkoutDetail, orderId, companyId, type);
    }
  };
  return (
    <>
      <SidebarWrapper
        {...shoppingCardStyles}
        className={classNames('shopping-cart-button', { 'shopping-cart-button_with-border': !shoppingCardStyles })}
        onClick={handleClick}
      >
        <div className='shopping-cart-button__shopping-icon'>
          <Icon size='medium' type={IconType.OUTLINED}>
            shopping_cart_outlined
          </Icon>
        </div>
        <SidebarWrapper className='shopping-cart-button__texts' {...shoppingCardStyles}>
          <h5>{t(`${tRoot}total`)}</h5>
        </SidebarWrapper>
        {parseCurrency(amount)}
        <Icon size='medium' className='shopping-cart-button__shopping-arrow'>
          {expanded ? 'expand_less' : 'expand_more'}
        </Icon>
      </SidebarWrapper>

      {expanded && (
        <SidebarWrapper
          className={classNames('shopping-cart-detail', { 'shopping-cart-detail-unset': !shoppingCardStyles })}
          {...shoppingCardStyles}
        >
          {orderTemplate.lineItems.map(({ quantity, unitPrice, name }, index) => (
            <ProductRow
              key={`${name}-${index}`}
              name={name}
              quantity={quantity}
              quantityLabel={t(`${tRoot}quantity`)}
              unitPrice={parseCurrency(unitPrice)}
            />
          ))}
          {canShowAdditionalLines && (
            <AdditionalChargesSection
              parseCurrencyFunction={parseCurrency}
              orderTemplate={{ ...orderTemplate, subtotal }}
              labels={additionalChargesLabels}
            />
          )}
        </SidebarWrapper>
      )}
    </>
  );
};
